import React from 'react';
import './key.css';
import { noteToKey } from '../constants.js';
import _ from 'lodash';

function Key(props) {
  let keyClassName = 'key';
  const isFlat = note => {
    return note.length > 2;
  }
  const isPressed = (note, pressedKeys) => {
    return _.includes(pressedKeys, noteToKey[note]);
  }
  if (isFlat(props.note)) keyClassName += ' flat';
  if (isPressed(props.note, props.pressedKeys)) keyClassName += ' pressed';
  
  if (isFlat(props.note)) return <div className={keyClassName}/>
  return <div className={keyClassName}><div className='letterContainer'>{noteToKey[props.note].toUpperCase()}</div></div>
}

export default Key